module.exports = __webpack_public_path__ + "static/IMG-20200907-WA0016-8a568dbe60c4b93ecad20221d575207c.jpg";